import React from 'react';
import { SDS } from '@schibsted-ufo/ui-components';
import { StyledToast, StyledMessage, StyledCloseButton } from './Toast.styles';

const getIconAsSDSProps = (icon: SDS.IconNames | undefined) => (icon ? { name: icon, placement: 'left' } : {});

export type TToastProps = {
    id: string;
    status: 'neutral' | 'success' | 'alert' | 'error';
    message: string;
    title?: string;
    icon?: SDS.IconNames;
    onDismiss: (id: string) => void;
};

export const Toast = ({
    id,
    status,
    message,
    title,
    icon,
    onDismiss,
}: TToastProps) => (
    <StyledToast
        version="primary"
        status={ status }
        icon={ getIconAsSDSProps(icon) }
        data-testid="toast-notification"
    >
        <StyledMessage>
            {title && (
                <SDS.Typography variant="body-s" weight={ 700 }>
                    {title}
                </SDS.Typography>
            )}
            <SDS.Typography variant="body-s" weight={ 400 }>
                {message}
            </SDS.Typography>
        </StyledMessage>
        <StyledCloseButton aria-label="Close" role="button" name="close" onClick={ () => onDismiss(id) } />
    </StyledToast>
);
